import React from 'react';
import Component, { DynamicFormProps } from './component';

const Form = (props: DynamicFormProps) => <Component {...props} />;

export default Form;

export { Component as component };
export type { DynamicFormProps };
